import axios from "axios";

axios.interceptors.response.use(
    (response) => response,
    (err) => {
        const status = err.response?.status;

        if (status === 440) {
            localStorage.clear();
            window.location.href = "/login";
            return;
        }

        if (status === 403) {
            window.location.href = "/unauthorized";
            return Promise.reject(err);
        }

        return Promise.reject(err);
    }
);

export default axios;
